import Vue from "vue";
import App from "../portal/index.vue";
import router from "../router";
import store from "../store";
import ViewUI from "view-design";
import axios from "axios";
import VueAxios from "vue-axios";
import md5 from 'js-md5';
// import "view-design/dist/styles/iview.css";
import "../utils/core.css";
import $ from "jquery";
import { get, post } from "../api";
import core from '../utils/core'
import VueCropper from 'vue-cropper'
import '../utils/debounce'
import '../utils/Bus'
import '../utils/hasPermi'
import '../utils/showTerminal'

import ElementResizeDetectorMaker from "element-resize-detector"

Vue.use(VueCropper)

Vue.prototype.$core = core;
axios.defaults.timeout = 300000;
Vue.use(ViewUI, VueAxios, axios);
Vue.prototype.axios = axios;

Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.config.productionTip = false;
Vue.prototype.$md5 = md5;
Vue.prototype.$ = $;
Vue.prototype.$erd = ElementResizeDetectorMaker()

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
